module.exports = __webpack_public_path__ + "img/cta-maserati.8e653531.jpg";